export const getMicSourceStream = async (
  context: AudioContext,
  deviceId = "default"
) => {
  if (navigator.mediaDevices.getUserMedia) {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        audio: { deviceId },
      });

      return context.createMediaStreamSource(stream);
    } catch (error) {
      console.log("The following gUM error occurred: ", error);
      return null;
    }
  } else {
    console.log("getUserMedia not supported on your browser!");
    return null;
  }
};
export const getSourceFromAudioFile = async (
  context: AudioContext,
  file: File
) => {
  const source = context.createBufferSource();
  const audioBuffer = await context.decodeAudioData(await file.arrayBuffer());
  source.buffer = audioBuffer;
  return source;
};
